var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserpresent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7071 17.2929C14.3166 16.9024 13.6834 16.9024 13.2929 17.2929C12.9024 17.6834 12.9024 18.3166 13.2929 18.7071L14.7071 17.2929ZM16 20L15.2929 20.7071C15.6834 21.0976 16.3166 21.0976 16.7071 20.7071L16 20ZM22.7071 14.7071C23.0976 14.3166 23.0976 13.6834 22.7071 13.2929C22.3166 12.9024 21.6834 12.9024 21.2929 13.2929L22.7071 14.7071ZM3 20C3 20.5523 3.44772 21 4 21C4.55228 21 5 20.5523 5 20H3ZM12.75 15C13.3023 15 13.75 14.5523 13.75 14C13.75 13.4477 13.3023 13 12.75 13V15ZM13.2929 18.7071L15.2929 20.7071L16.7071 19.2929L14.7071 17.2929L13.2929 18.7071ZM16.7071 20.7071L22.7071 14.7071L21.2929 13.2929L15.2929 19.2929L16.7071 20.7071ZM5 20V19H3V20H5ZM5 19C5 16.7909 6.79086 15 9 15V13C5.68629 13 3 15.6863 3 19H5ZM14 7C14 8.65685 12.6569 10 11 10V12C13.7614 12 16 9.76142 16 7H14ZM11 10C9.34315 10 8 8.65685 8 7H6C6 9.76142 8.23858 12 11 12V10ZM8 7C8 5.34315 9.34315 4 11 4V2C8.23858 2 6 4.23858 6 7H8ZM11 4C12.6569 4 14 5.34315 14 7H16C16 4.23858 13.7614 2 11 2V4ZM9 15H12.75V13H9V15Z",
    fill: "#975DD5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserpresent);
export default __webpack_public_path__ + "static/media/userpresent.4be31eb50f9dd5fe665bac623c3bea74.svg";
export { ForwardRef as ReactComponent };